<template>
  <div>
    <v-row class="list__item">
      <v-text-field
        label="Ссылка для автозагрузки Satu.kz"
        :color="colors.aqua"
        v-model="satuYML"
        light
        required
      ></v-text-field>
      <v-btn
        icon
        class="mt-3 ml-2"
        @click="onCopyLink"
        ref="copyContainerSatu"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </v-row>
    <v-row class="list__item">
      <v-flex xs9>
        <v-avatar left color="color--red-300" class="mr-4">
          <v-icon color="white">mdi-cart</v-icon> </v-avatar
        >В продаже на Satu.kz
      </v-flex>
      <v-flex xs3 justify-end>
        <v-switch
          class="mt-2 v-switch"
          v-model="dataSourceSettingsForm.enabledSatu"
          :color="colors.aqua"
        ></v-switch>
      </v-flex>
    </v-row>
  </div>
</template>

<script>
import ColorPaletteMixin from "@/mixins/ColorPalette";
import { mapFields } from "vuex-map-fields";

export default {
  name: "SatuPopupContent",
  props: {
    downloadLinks: Object,
  },
  mixins: [ColorPaletteMixin],
  data() {
    return {
      satuYML: this.downloadLinks.satuyml,
    };
  },
  computed: {
    ...mapFields("formModels", ["dataSourceSettingsForm"]),
  },
  methods: {
    onCopyLink() {
      this.$copyText(this.satuYML, this.$refs["copyContainerSatu"].$el);
    },
  },
};
</script>

<style>
</style>